module.exports = "<div class=\"row\">{{title}}</div>"